import { Fragment } from 'react';
import type { NextPage } from 'next';
import { fadeInAnimate, slideInDownAnimate } from 'utils/animation';
import NextLink from 'components/reuseable/links/NextLink';
// -------- custom component -------- //
import { Hero1 } from 'components/blocks/hero'; 
import ContactFooterCombo from 'components/reuseable/ContactFooterCombo'; 

import Video from 'components/blocks/video/Video';

import SEO from 'components/common/SEO';
import * as All from 'data/keywords';  

const details = {
  pageName: 'Ecommerce SEO Agency',
  categories: 'seo, web design',
  description:
    'SEOptimist is an Ecommerce SEO Agency dedicated to improving your site ranking. Get your free technical SEO audit now from SEOptimist audit London',
  parentDirectories: ''
};

const mainPages: NextPage = () => {
  return (
    <>
      {/* ========== SEO META values ========== */}
      <SEO
        title={`${All.EcommerceSEO[0].title}`}
        description={details.description}
        tag={details.categories}
        urlPT={``}
        urlENPT={``}
        url={`${All.EcommerceSEO[0].url}/${All.EcommerceSEO[0].title.toLowerCase().replace(/ /g, '-')}`}
        image={`img/${All.HomeList[0].title.toLowerCase().replace(/ /g, '-')}.jpg`}
        // updated=""
        // published=""
        // modified=""
      />

      {/* ========== heading section ========== */}
      <Fragment>
        
        <main className="content-wrapper bg-white">
          {/* ========== hero section ========== */}
          <div style={fadeInAnimate('900ms')}>
            <Video
              heading={All.EcommerceSEO[0].title}
              title1="AI"
              title2="SEO"
              title3=""
              movie="/1.mp4"
              placeholder="1-bg.jpg"
              button="website-test"
              fontsize1={150}
              fontsize2={150}
              body=""
              intro="helps London companies improve Google ranking with our free SEO audit. If&nbsp;you&nbsp;want to accelerate
              your business online, we are the experts using proprietary technology and AI."
            />
          </div>{' '}
          <div className="container">
            <div className="row">
              <div className="col-lg-7 mx-auto">
                <h2>{All.EcommerceSEO[0].title}</h2> {/*ecommerce SEO agency */}
                <p>
                  Welcome to the world of SEOptimist, your{' '}
                  <NextLink
                    title={All.CRO[0].title}
                    href={'/' + All.CRO[0].url + '/' + All.CRO[0].title.toLowerCase().replace(/ /g, '-')}
                  />
                  , where we are committed to elevating your e-commerce business to new heights. In this rapidly
                  evolving digital age, establishing a strong online presence is paramount for the success of any
                  e-commerce venture. With countless competitors vying for attention in the crowded digital marketplace,
                  it's essential to find innovative ways to ensure that your brand not only stands out but also attracts
                  the right customers. This is where our cutting-edge {All.EcommerceSEO[0].title}, SEOptimist, steps in.
                  We specialize in providing tailored strategies and solutions designed to maximize your online
                  visibility and drive targeted organic traffic to your website.
                </p>
                <p>
                  At SEOptimist, we understand the unique challenges and opportunities that e-commerce businesses face.
                  Our team of seasoned professionals has extensive experience in the e-commerce industry, and we have a
                  deep understanding of the ever-changing landscape. We know what it takes to position your brand
                  effectively, optimize your website for search engines, and attract high-quality organic traffic that
                  converts into loyal customers.
                </p>
                <p>
                  As an {All.EcommerceSEO[0].title}, we offer a comprehensive range of services to meet your specific
                  needs. From conducting in-depth keyword research and optimizing your website's on-page elements to
                  creating engaging content and building high-quality backlinks, we leave no stone unturned in our quest
                  to enhance your online visibility and drive growth. Our team utilizes advanced tools and
                  industry-leading techniques to stay ahead of the curve and deliver outstanding results.
                </p>
                <p>
                  One of the key pillars of our approach is our commitment to understanding your unique business goals
                  and target audience. We believe that every e-commerce business is unique, and a one-size-fits-all
                  approach simply won't cut it. That's why we take the time to get to know your business inside out,
                  identifying your target market, understanding your brand's strengths and USPs, and developing
                  customized strategies that align with your objectives.
                </p>
                <p>
                  Partnering with SEOptimist means gaining a strategic ally dedicated to your e-commerce success. We work
                  hand in hand with you to develop and implement data-driven strategies that leverage the power of SEO
                  to drive organic growth and improve your bottom line. Our team is continuously monitoring, analyzing,
                  and optimizing your SEO campaigns to ensure that you stay ahead of the competition and adapt to the
                  ever-changing digital landscape.
                </p>
              </div>
            </div>
          </div>
          
          <Hero1
            bgcolor="bg-soft-primary mb-20 pt-20"
            title={``}
            lead={``}
            body={[
              <div key={100} className="text-center" id="report">
                <p className="text-center fs-34 mb-0 mx-auto">
                  <strong>
                    GET YOUR FREE <span className="text-fuchsia">TECHNICAL SEO REPORT</span>
                  </strong>
                </p>
                <p className="text-center fs-18 mx-auto">
                  Action the findings from the report or purchase {All.HomeList[8].title}
                </p>
              </div>
            ]}
          />
          <div className="container">
            <div className="row">
              <div className="col-lg-7 mx-auto">
                <h2>{All.EcommerceSEO[1].title}s</h2> {/* ecommerce SEO specialist */}
                <p> 
                  As {All.EcommerceSEO[1].title}s, we recognize that every online store is unique, with its own set of
                  goals, target audience, and industry dynamics. That's why our team of seasoned SEO experts takes a
                  personalized approach, tailoring our strategies to align with your specific business objectives.
                  Whether you're a startup looking to establish your digital presence or an established brand aiming to
                  dominate your niche, we have the tools, techniques, and expertise to make it happen.
                </p>
                <p>
                  With years of experience under our belt, we have developed a deep understanding of the intricacies of
                  e-commerce SEO. We stay at the forefront of industry trends and algorithm updates, continuously
                  refining our strategies to ensure maximum effectiveness. From conducting comprehensive keyword
                  research and optimizing your website's structure and content to implementing technical SEO best
                  practices and building authoritative backlinks, we leave no stone unturned in our pursuit of improving
                  your online visibility and driving targeted organic traffic to your online store.
                </p>
                <p>
                  What sets us apart as an {All.EcommerceSEO[1].title} is our unwavering commitment to staying ahead of
                  the curve. Our team is constantly monitoring and analyzing data, identifying emerging trends and
                  opportunities, and adapting our strategies to ensure that you maintain a competitive edge. We utilize
                  cutting-edge tools and advanced analytics to measure the effectiveness of our campaigns and make
                  data-driven decisions that yield tangible results.
                </p>
                <p>
                  At SEOptimist, we are more than just a service provider. We strive to be your trusted partner in
                  navigating the complex world of e-commerce SEO. Our team takes the time to understand your unique
                  business goals, target audience, and competitive landscape, enabling us to develop tailored strategies
                  that deliver long-term success. We believe in fostering a collaborative relationship with our clients,
                  providing transparent communication, regular progress reports, and dedicated support every step of the
                  way.
                </p>
                <h2>{All.EcommerceSEO[2].title}</h2> {/* e commerce SEO expert */}
                <p>
                  One of the key elements that set us apart from the competition is our deep understanding of e-commerce
                  platforms. Whether you're operating on Shopify, WooCommerce, Magento, or any other popular platform,
                  we have extensive experience in optimizing websites on these platforms. Our{' '}
                  {All.EcommerceSEO[2].title}s will conduct a comprehensive audit of your website, identifying areas for
                  improvement and developing a customized SEO plan to enhance your website's visibility in search engine
                  results pages (SERPs). All along the process, you will be accompanied by a true{' '}
                  {All.EcommerceSEO[2].title}.
                </p>
                <h2>{All.EcommerceSEO[3].title}</h2> {/* e commerce SEO company */}
                <p>
                  SEOptimist is not just another {All.EcommerceSEO[3].title}: we believe that SEO is not a
                  one-size-fits-all solution. That's why we take a holistic approach to e-commerce SEO, considering
                  every aspect that influences your website's performance. From on-page optimization, including keyword
                  research and content optimization, to technical SEO elements like site structure and mobile
                  optimization, we leave no stone unturned in our quest to boost your website's rankings. This is why we
                  are a leading and successful {All.EcommerceSEO[3].title}.
                </p>
                <h2>{All.EcommerceSEO[4].title}</h2> {/* ecommerce SEO audit */}
                <p>
                  At SEOptimist, we pride ourselves on our comprehensive approach to {All.EcommerceSEO[4].title}s. We
                  understand that a strong foundation is crucial for the success of any online store, and that's why we
                  go beyond surface-level optimizations. Our team of highly skilled professionals possesses a deep
                  understanding of the technical intricacies that can impact your website's search engine rankings.
                </p>
                <p>
                  When it comes to {All.EcommerceSEO[4].title}s, we leave no stone unturned. Our experts utilize the
                  latest industry tools and techniques to conduct in-depth keyword research, analyzing search volumes,
                  competition, and search intent to identify high-value keywords that align with your specific business
                  niche. These strategic keywords serve as the building blocks of your SEO strategy, allowing us to
                  optimize your website's content, meta tags, and product descriptions to increase visibility and
                  attract relevant organic traffic.
                </p>
                <p>
                  But our {All.EcommerceSEO[4].title} services don't stop there. We delve into the technical aspects of
                  your website, analyzing its structure, crawlability, and indexability. Our team conducts a thorough
                  review of your website's architecture, ensuring that it is optimized for search engine crawlers and
                  that there are no technical barriers that hinder search engine bots from properly indexing your pages.
                  We also assess your website's load speed, mobile responsiveness, and user experience, as these factors
                  play a crucial role in both search engine rankings and user satisfaction.
                </p>
                <p>
                  As a highly technical SEO agency, we employ a range of advanced tools and methodologies to conduct a
                  comprehensive website SEO audit. We analyze your website's backlink profile, assessing the quality and
                  relevance of your inbound links. We identify any potential issues that could be negatively impacting
                  your search engine rankings and provide actionable recommendations to address them.
                </p>
                <p>
                  At SEOptimist, we understand that an {All.EcommerceSEO[4].title} is not a one-time event, but rather an
                  ongoing process. As part of our commitment to delivering sustainable results, we provide regular
                  monitoring and reporting, allowing us to track the progress of your website's SEO performance and make
                  data-driven decisions to continually improve its visibility and organic rankings.
                </p>
                <p>
                  By partnering with SEOptimist for your {All.EcommerceSEO[4].title}, you can rest assured that you are
                  receiving highly qualitative and customized services. SEOptimist is a deeply{' '}
                  <NextLink title={All.HomeList[0].title} href={'/'} /> that provides highly qualitative{' '}
                  <NextLink
                    title={All.SEOAudit[1].title}
                    href={'/' + All.SEOAudit[0].url + '/' + All.SEOAudit[0].title.toLowerCase().replace(/ /g, '-')}
                  />
                  . Our team of experts combines technical expertise, industry knowledge, and a data-driven approach to
                  provide you with an in-depth understanding of your website's SEO performance and actionable insights
                  to drive growth.
                </p>
                <h2>{All.EcommerceSEO[5].title}</h2> {/* e commerce SEO consultant */}
                <p>
                  In addition to on-page optimization, our {All.EcommerceSEO[5].title} team is well-versed in off-page
                  SEO strategies that build your website's authority and credibility. We employ ethical and white-hat
                  link building techniques to acquire high-quality backlinks from reputable websites in your industry.
                  SEOptimist will act as your personal {All.EcommerceSEO[5].title} by establishing a robust network of
                  backlinks, giving your website credibility in the eyes of search engines, which can significantly
                  improve your rankings and organic traffic over time.
                </p>
                <h2>{All.EcommerceSEO[6].title}</h2> {/*ecommerce SEO packages */}
                <p>
                  At SEOptimist, we go above and beyond to provide you with comprehensive and customizable{' '}
                  {All.EcommerceSEO[6].title} that cater to the unique needs and goals of your online business. We
                  understand that every e-commerce website is different, and that's why we offer a range of packages
                  designed to meet your specific requirements.
                </p>
                <p>
                  Our team of experienced SEO professionals is dedicated to staying ahead of the curve in the
                  ever-evolving world of search engine optimization. We closely monitor the latest algorithm updates,
                  industry trends, and emerging technologies to ensure that your e-commerce website remains optimized
                  for search engines' evolving requirements. By staying on top of the latest SEO best practices, we can
                  adapt our strategies to keep your business ahead of the competition.
                </p>
                <p>
                  When it comes to our {All.EcommerceSEO[6].title}, we offer a variety of services that can give your
                  online store the competitive edge it needs. Whether it's optimizing your website for voice search to
                  capture the growing number of voice-enabled device users, leveraging structured data markup to enhance
                  the visibility and appeal of your product listings in search results, or implementing schema markup to
                  provide search engines with more context about your products, we have the expertise to implement these
                  advanced techniques.
                </p>
                <p>
                  Our {All.EcommerceSEO[6].title} are tailored to suit businesses of all sizes and budgets. We
                  understand that your goals and priorities may vary, and that's why we offer flexibility in our
                  packages. Whether you're looking for a comprehensive SEO overhaul or specific targeted optimizations,
                  we can create a package that aligns with your requirements and delivers tangible results.
                </p>
                <p>
                  By choosing one of our {All.EcommerceSEO[6].title}, you can expect a strategic and data-driven
                  approach to optimizing your online store. Our team will conduct in-depth keyword research, analyze
                  your competitors, and perform a thorough audit of your website to identify areas for improvement. We
                  will then develop a tailored SEO strategy that focuses on increasing your website's visibility,
                  driving relevant organic traffic, and ultimately boosting your conversions and revenue.
                </p>
                <p>
                  With our {All.EcommerceSEO[6].title}, you can have peace of mind knowing that your online business is
                  in the hands of experts who are dedicated to your success. We will provide you with regular reports
                  and transparent communication, keeping you informed of the progress and results of our SEO efforts.
                  Our team is always available to answer any questions, address any concerns, and provide ongoing
                  support as your business continues to grow.
                </p>
                <h2>{All.EcommerceSEO[7].title}</h2> {/* SEO ecommerce agency */}
                <p>
                  When you partner with SEOptimist, you gain more than just an {All.EcommerceSEO[7].title}. You gain a
                  dedicated team of professionals who are committed to your success. We take the time to understand your
                  business objectives, target audience, and competitive landscape, allowing us to create a tailored SEO
                  strategy that aligns with your unique needs. Our transparent reporting and regular communication keep
                  you informed of the progress we're making, ensuring that you always have a clear picture of how our
                  efforts are driving results for your e-commerce business. Choosing SEOptimist is choosing a leading and
                  trusted {All.EcommerceSEO[7].title}. Don't let your e-commerce website get lost in the vast sea of
                  competitors. Get to know our{' '}
                  <NextLink
                    title={All.SEOAudit[1].title}
                    href={'/' + All.SEOAudit[0].url + '/' + All.SEOAudit[0].title.toLowerCase().replace(/ /g, '-')}
                  />
                  . Take charge of your online presence with SEOptimist. Contact us today to discuss your business goals
                  and let our team of experts devise a comprehensive SEO strategy that propels your e-commerce business
                  to new heights of success. Together, we can unlock the full potential of your online store and drive
                  sustainable growth in the ever-competitive e-commerce landscape.
                </p>  
              </div>
            </div>
          </div>
         </main>
          <ContactFooterCombo location="london" />
          
      </Fragment>
    </>
  );
};

export default mainPages;
